import { localeMapping, topQuestionSlug, topQuestion } from '@/modules/config/zendesk'
import ZendeskApi from '@/modules/api/zendesk-api'

const zendeskApi = new ZendeskApi()

const state = {
  sections: [],
  articles: [],
  results: [],
  activeSection: null,
  searchQuery: '',
  focusSearch: false,
  articlesLoading: false,
  page: 1,
  count: 0
}

const getters = {
  objectBySlug: (state) => (type, slug) => {
    if (slug === topQuestionSlug) {
      return topQuestion
    } else {
      return state[type].find(obj => Number(obj.id) === Number(slug.split('-')[0]))
    }
  }
}

const mutations = {
  setSections (state, array) {
    state.sections = array
  },
  setArticles (state, array) {
    state.articles = array
  },
  setResults (state, array) {
    state.results = array
  },
  setActiveSection (state, string) {
    state.activeSection = string
  },
  setSearchQuery (state, text) {
    state.searchQuery = text
  },
  setFocusSearch (state, boolean) {
    state.focusSearch = boolean
  },
  setArticlesCount (state, integer) {
    state.count = integer
  },
  setArticlesPage (state, integer) {
    state.page = integer
  },
  setArticlesLoading (state, boolean) {
    state.articlesLoading = boolean
  }
}

let params = {
  locale: localeMapping[I18n.language]
}

const actions = {
  async fetchSections ({ commit }) {
    const data = await zendeskApi.fetchSections(params)
    commit('setSections', data.sections)
  },

  async fetchArticles ({ commit }, query) {
    commit('setArticlesLoading', true)
    let articles = []
    let count = 0

    params = Object.assign(params, {
      query: query,
      page: state.page,
      per_page: 10
    })

    if (state.activeSection || query) {
      const data = await zendeskApi.fetchArticles(state.activeSection, params)
      articles = data.articles || data.results
      count = data.count
    }
    commit('setArticles', articles)
    commit('setArticlesCount', count)
    commit('setArticlesLoading', false)
  },

  async fetchArticle ({ commit }, articleId) {
    const data = await zendeskApi.fetchArticle(articleId, params)
    return data.article
  },

  async fetchSearchResults ({ commit }) {
    let results = []

    if (state.searchQuery.length > 1) {
      params = Object.assign(params, {
        query: state.searchQuery,
        per_page: 5
      })
      const data = await zendeskApi.fetchArticles(null, params)
      results = data.results
    }
    commit('setResults', results)
    commit('setArticlesLoading', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
